import { defineMeta } from '@/registry/types';

export const detailsPageLayoutMeta = defineMeta({
  name: 'DetailsPageLayout',
  level: 'template',
  category: 'layout',
  classification: 'custom',
  description: 'Entity detail page with header (breadcrumbs/title/actions), content column and side panel.',
  baseLibrary: 'custom',
  a2uiEquivalent: 'DetailPage',
  importPath: '@/templates/DetailsPageLayout',
  requiredProps: ['title', 'children'],
  optionalProps: ['breadcrumbs', 'actions', 'aside'],
  supportedStates: ['default', 'with-aside'],
  designTokens: ['spacing', 'typography'],
  accessibility: ['Breadcrumbs convey location; title is the page heading.'],
  usageExamples: ['<DetailsPageLayout title="prod-db-01" aside={<Card/>}>...</DetailsPageLayout>'],
  antiPatterns: ['Do not overload the aside with primary content.'],
  llmSafe: true,
  whenToUse: ['Asset/finding/entity detail screens'],
  whenNotToUse: ['Lists (use TablePageLayout)'],
});

export default detailsPageLayoutMeta;
